(function () {
  'use strict';

  var CACHE_KEY = 'avarrio_prices';
  var CACHE_MAX_AGE = 10 * 60 * 1000; // 10 minutes
  var CACHE_FRESH_AGE = 3 * 60 * 1000; // 3 minutes — skip fetch if cache is fresher
  var POLL_INTERVAL = 60 * 1000; // 60 seconds
  var FETCH_TIMEOUT = 5000; // 5 seconds

  var container = document.querySelector('.header_topbar');
  if (!container) return;

  var apiUrl = container.getAttribute('data-price-feed-url');
  if (!apiUrl) return;

  var ticker = container.querySelector('.price-ticker');
  var intervalId = null;

  function getCached() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (Date.now() - cached._cachedAt > CACHE_MAX_AGE) return null;
      return cached;
    } catch (e) {
      return null;
    }
  }

  function isCacheFresh() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return false;
      var cached = JSON.parse(raw);
      return Date.now() - cached._cachedAt <= CACHE_FRESH_AGE;
    } catch (e) {
      return false;
    }
  }

  function setCache(data) {
    try {
      data._cachedAt = Date.now();
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch (e) {
      // localStorage full or unavailable
    }
  }

  function renderPrices(data) {
    var prices = data.prices;
    var items = ticker.querySelectorAll('[data-price-key]');

    items.forEach(function (item) {
      var key = item.getAttribute('data-price-key');
      var price = prices[key];
      if (!price) return;

      var valueEl = item.querySelector('.price-ticker__value');
      if (valueEl) valueEl.textContent = price.formatted;

      var changeEl = item.querySelector('.price-ticker__change');
      if (changeEl) {
        var pct = price.change_pct;
        var abs = Math.abs(pct);
        var arrow = '';

        if (pct > 0) {
          changeEl.className = 'price-ticker__change price-ticker__change--up';
          arrow = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 2L8.5 6.5H1.5L5 2Z" fill="currentColor"/></svg>';
        } else if (pct < 0) {
          changeEl.className = 'price-ticker__change price-ticker__change--down';
          arrow = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 8L1.5 3.5H8.5L5 8Z" fill="currentColor"/></svg>';
        } else {
          changeEl.className = 'price-ticker__change price-ticker__change--zero';
        }

        changeEl.innerHTML = arrow + abs + '%';
      }
    });

    ticker.classList.remove('price-ticker--loading');
    ticker.classList.remove('price-ticker--unavailable');

    if (typeof publish === 'function') {
      publish('price-feed:update', data);
    }
  }

  function renderUnavailable() {
    ticker.classList.remove('price-ticker--loading');
    ticker.classList.add('price-ticker--unavailable');
  }

  function fetchPrices() {
    if (isCacheFresh()) return;

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT);

    fetch(apiUrl, { signal: controller.signal })
      .then(function (res) {
        clearTimeout(timeoutId);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data.prices) {
          setCache(data);
          renderPrices(data);
        } else {
          throw new Error('Invalid response');
        }
      })
      .catch(function () {
        clearTimeout(timeoutId);
        var cached = getCached();
        if (cached) {
          renderPrices(cached);
        } else {
          renderUnavailable();
        }
      });
  }

  // Try cached data first for instant render
  var cached = getCached();
  if (cached) renderPrices(cached);

  // Fetch fresh data immediately
  fetchPrices();

  // Poll every 60s
  intervalId = setInterval(fetchPrices, POLL_INTERVAL);

  // Pause polling when tab is hidden, resume when visible
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      clearInterval(intervalId);
      intervalId = null;
    } else {
      fetchPrices();
      intervalId = setInterval(fetchPrices, POLL_INTERVAL);
    }
  });
})();
